import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { createBooking } from '../services/firebase';

const WhatsAppLink = ({ model, funnelData, onComplete }) => {
  const [whatsappUrl, setWhatsappUrl] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const [error, setError] = useState(null);
  const [showWhatsApp, setShowWhatsApp] = useState(false);

  useEffect(() => {
    const generateWhatsAppMessage = () => {
      const formatDate = (dateObj) => {
        if (!dateObj || !dateObj.date) return 'Não especificada';
        const date = new Date(dateObj.date);
        if (isNaN(date.getTime())) return 'Não especificada';
        
        const options = { 
          weekday: 'long', 
          day: 'numeric', 
          month: 'long',
          timeZone: 'America/Sao_Paulo'
        };
        return date.toLocaleDateString('pt-BR', options);
      };

      const formatTime = (timeObj) => {
        if (!timeObj || typeof timeObj.hour !== 'number') return 'Não especificado';
        return `${timeObj.hour}:00`;
      };

      const message = [
        'Olá! Gostaria de confirmar meu agendamento:',
        '',
        `Data: ${formatDate(funnelData?.date)}`,
        `Horário: ${formatTime(funnelData?.time)}`,
        `Nome: ${funnelData?.clientInfo?.name || 'Não especificado'}`,
        `WhatsApp: ${funnelData?.clientInfo?.whatsapp || 'Não especificado'}`,
        '',
        'Por favor, confirme se está tudo correto.'
      ].join('\n');

      const encodedMessage = encodeURIComponent(message);
      // Remove any non-digit characters from the phone number
      const cleanPhone = (model?.whatsapp || '').replace(/\D/g, '');
      const url = `https://api.whatsapp.com/send/?phone=${cleanPhone}&text=${encodedMessage}&type=phone_number&app_absent=0`;
      setWhatsappUrl(url);
    };

    generateWhatsAppMessage();
  }, [model, funnelData]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(whatsappUrl);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  const handleCreateBooking = async () => {
    try {
      console.log('Iniciando criação do booking...');
      console.log('Dados do modelo:', model);
      console.log('Dados do funnel:', funnelData);

      // Criar objeto do agendamento
      const bookingData = {
        name: funnelData.clientInfo.name,
        whatsapp: funnelData.clientInfo.whatsapp,
        date: funnelData.date,
        hour: funnelData.time,
        note: funnelData.clientInfo.interest || '',
        username: model.username,
        status: 'new',
        modelId: model.username
      };

      console.log('Dados do agendamento preparados:', bookingData);

      // Salvar no Firebase
      console.log('Tentando salvar no Firebase...');
      const bookingId = await createBooking(bookingData);
      console.log('Resposta do Firebase:', bookingId);

      if (!bookingId) {
        throw new Error('Falha ao criar agendamento');
      }

      console.log('Agendamento criado com sucesso!');
      onComplete({ clicked: true, timestamp: new Date().toISOString() });
      setShowWhatsApp(true);
    } catch (err) {
      console.error('Erro ao criar agendamento:', err);
      setError('Erro ao criar agendamento: ' + err.message);
    }
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h3 className="text-2xl font-semibold text-gray-900 mb-4">
          Agendamento Confirmado!
        </h3>
        <p className="text-gray-600 text-lg">
          {!showWhatsApp 
            ? "Clique no botão abaixo para finalizar seu agendamento e falar comigo."
            : "Seu agendamento foi registrado com sucesso! Copie o número abaixo para iniciar a conversa."}
        </p>
      </div>

      {error && (
        <div className="bg-red-50 text-red-600 p-4 rounded-lg">
          {error}
        </div>
      )}

      <div className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border border-gray-100">
        <div className="space-y-6">
          <div className="flex items-center justify-center">
            <svg
              className="w-16 h-16 text-green-500"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
          </div>

          {!showWhatsApp ? (
            <div className="flex flex-col items-center gap-4">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleCreateBooking}
                className="bg-green-500 text-white rounded-xl py-4 px-8 flex items-center justify-center text-lg font-medium hover:bg-green-600 transition-colors shadow-md"
              >
                Me chama no Whatsapp
              </motion.button>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-4">
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full max-w-md">
                <p className="text-sm text-gray-500 mb-2">Número do WhatsApp:</p>
                <div 
                  className="text-xl font-medium text-gray-900 cursor-pointer hover:bg-white p-3 rounded-lg border border-gray-200 transition-colors flex items-center justify-between"
                  onClick={() => {
                    navigator.clipboard.writeText(model?.whatsapp || '');
                    setIsCopied(true);
                    setTimeout(() => setIsCopied(false), 2000);
                  }}
                >
                  <span>{model?.whatsapp || 'Não disponível'}</span>
                  {isCopied ? (
                    <span className="text-sm text-green-500 flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      Copiado!
                    </span>
                  ) : (
                    <span className="text-sm text-gray-400">Clique para copiar</span>
                  )}
                </div>
                <p className="text-sm text-gray-500 mt-3 text-center">
                  Copie o número e salve nos seus contatos para iniciar a conversa
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhatsAppLink; 